import { NavItem } from '../vertical/sidebar/nav-item/nav-item';

export type NavRouteTuple = [displayName: string, route: string, iconName?: string];

export const buildNavItems = (routes: NavRouteTuple[]): NavItem[] =>
  routes.map(([displayName, route, iconName = '']) => ({
    displayName,
    iconName,
    route,
  }));

export const HORIZONTAL_NAV_CONFIG: NavRouteTuple[] = [
  ['Home', 'home/users'],
  ['Reports', 'home/report'],
  ['Account Statement', 'home/account-statement'],
  ['Betting P/L', 'home/settled-markets'],
  ['Live PnL', 'home/live-markets'],
  ['Bet Info', 'home/bet-info'],
  ['Payments', 'home/payments', 'payments'],
  ['Registered Player Report', 'home/registered-player-report', 'person_add'],
  ['Client PNL Report', 'home/client-pnl-report', 'bar_chart'],
  ['White Labels', 'home/white-label'],
  ['Betfair Accounts', 'configuration/betfair-accounts'],
  ['Commission', 'home/commission'],
  ['Static Commission', 'home/static-commission'],
  ['Risk Taking', 'home/risk'],
  ['Static Risk', 'home/static-risk'],
  ['Exchange Rate', 'configuration/exchange-rate'],
  ['Supported Countries', 'settings/supported-countries'],
  ['Supported Sports', 'settings/supported-sports'],
  ['Settlement', 'home/settlement'],
  ['Roles', 'settings/roles'],
  ['Change Password', 'home/reset-password'],
  ['Bet Ticker V1', 'home/bet-ticker-v1'],
  ['Bet Ticker', 'home/bet-ticker'],
  ['PSP Admin', 'home/psp-admin'],
  ['KJsport9 Admin', 'home/kjsport9-admin'],
  ['Feature Flags', 'configuration/feature-flags'],
  ['Audit Log', 'home/audit-log'],
  ['Bet Violations', 'home/bet-violations', 'gpp_bad'],
  ['VPN Whitelist', 'home/vpn-whitelist', 'vpn_lock'],
  ['Services Config', 'home/services-config'],
  ['Sports Navigation', 'home/navigation-config'],
  ['BM Fancy Nav Config', 'home/bm-fancy-nav-config'],
  ['Casino Navigation', 'home/casino-navigation-config'],
  ['Permissions', 'home/user-permissions'],
  ['Operators', 'home/operators'],
  ['Bet Config', 'home/bet-config'],
  ['Customer Support', 'settings/support-channels'],
];

export const VERTICAL_HOME_CONFIG: NavRouteTuple[] = [
  ['Starter', '/starter', 'home'],
  ['Home', 'home/users', 'home'],
  ['Betting P/L', '/starter', 'home'],
  ['Account Statement', '/reports', 'home'],
  ['Bet Info', 'home/bet-info', 'home'],
  ['Payments', 'home/payments', 'payments'],
  ['Registered Player Report', 'home/registered-player-report', 'person_add'],
  ['Client PNL Report', 'home/client-pnl-report', 'bar_chart'],
  ['White Labels', 'home/white-label', 'home'],
  ['Bet Violations', 'home/bet-violations', 'gpp_bad'],
];

export const VERTICAL_CONFIG_ITEMS: NavRouteTuple[] = [
  ['Betfair Accounts', 'configuration/betfair-accounts', 'home'],
  ['Commission', 'home/commission', 'home'],
  ['Risk Taking', 'home/risk', 'home'],
  ['Exchange Rate', 'configuration/exchange-rate', 'home'],
  ['VPN Whitelist', 'home/vpn-whitelist', 'vpn_lock'],
];

export const VERTICAL_SETTINGS_ITEMS: NavRouteTuple[] = [
  ['Supported Countries', 'settings/supported-countries', 'home'],
  ['Supported Sports', 'settings/supported-sports', 'home'],
  ['Roles', 'settings/roles', 'home'],
  ['Customer Support', 'settings/support-channels', 'home'],
];
